<template>
  <div
    class="form"
    style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/difference-background.png')"
  >
    <FormHeader :datalayerName="datalayerName"></FormHeader>
    <FormSupporterDetails
      :datalayerName="datalayerName"
      :programName="programName"
      :messageId="messageId"
      :requirePhone="requirePhone"
      :thankYouUrl="thankYouUrl"
      :privacyPolicyUrl="privacyPolicyUrl"
    ></FormSupporterDetails>
  </div>
</template>

<script>
import FormHeader from "./form-components/Header.vue";
import FormSupporterDetails from "./form-components/SupporterDetails.vue";
import FormMessageViewer from "./form-components/MessageViewer.vue";

export default {
  name: "ActionForm",
  components: {
    FormHeader,
    FormSupporterDetails,
    FormMessageViewer,
  },
  props: {
    datalayerName: {
      type: String,
      required: true,
    },

    // MARKETO
    programName: {
      type: String,
      required: true,
    },

    messageId: {
      type: String,
    },
    
    requirePhone:{
      type: Boolean,
      default: false
    },
    
    thankYouUrl: {
      type: String,
      default: "https://wwf.org.au/thank-you-for-making-a-difference/"
    },

    privacyPolicyUrl: {
      type: String,
      default:"https://wwf.org.au/about-us/privacy-policy/"
    },
  },
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;

  padding: 200px 0;
  width: 100%;
  height: 100%;

  background-color: #1c3226;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

@media screen and (max-width: 800px) {
  .form {
    margin: 0 -64px;
  }
}
</style>


// WEBPACK FOOTER //
// ActionForm.vue?617639b8